import {HttpService} from "../http/Http.service";
import {HttpErrorService} from "../http/HttpError.service";
import {SendStatusType} from "../../model/models";
import {BaseType} from "antd/es/typography/Base";

export class SendUtils {

    static async downloadDocument(iun: string, key: string, onComplete?: () => void) {
        try {
            const blob = await this.fetchOrFallbackBlob(iun, key);
            if (!blob) return;

            const isPdf = key.toLowerCase().endsWith(".pdf");
            const mimeType = isPdf ? "application/pdf" : "application/octet-stream";
            const fileName = decodeURIComponent(key.split("/").pop() || "file");

            const url = URL.createObjectURL(new Blob([blob], { type: mimeType }));

            if (isPdf) {
                window.open(url);
            } else {
                const link = document.createElement("a");
                link.href = url;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }

            setTimeout(() => URL.revokeObjectURL(url), 5000);

        } finally {
            if (onComplete) onComplete();
        }
    }


    static async fetchOrFallbackBlob(iun: string, key: string): Promise<Blob | null> {

        const fetchFile = async (url: string): Promise<Blob> => {
            const response = await HttpService.getInstanceAxios().get(url, {
                responseType: "blob",
            });
            return response.data;
        };

        try {
            const keyEncoded = encodeURIComponent(key);
            const fallbackUrl = `/send/document/${iun}?key=${keyEncoded}`;
            return await fetchFile(fallbackUrl);
        } catch (error) {
            HttpErrorService.handle("Errore durante il download del documento", error, true);
            return null;
        }
    }

    static getStatusColor(status:SendStatusType):BaseType{
        switch (status) {
            case "ACCEPTED": return "secondary";
            case "IN_VALIDATION": return "secondary";
            case "REFUSED": return "danger";
            case "DELIVERING": return "secondary";
            case "DELIVERED": return "warning";
            case "VIEWED": return "success";
            case "EFFECTIVE_DATE": return "success";
            case "PAID": return "warning";
            case "UNREACHABLE": return "warning";
            case "CANCELLED": return "secondary";
            case "RETURNED_TO_SENDER": return "danger";
        }
        return "secondary";
    }

    static getErrorCodeDecoded(errorCode:string):string{

        if( errorCode==null )
            return "";

        switch (errorCode) {
            case "FILE_NOTFOUND" : return " I riferimenti dei documenti nella notifica non sono corretti o i documenti non sono stati caricati con successo.";
            case "FILE_GONE" : return "Allegato non disponibile: superati i termini di conservazione";
            case "FILE_SHA_ERROR" : return " Il digest calcolato con algoritmi sha256 dei documenti inseriti non è corrispondete a quello del file referenziato.";
            case "FILE_PDF_INVALID_ERROR" : return "Il file inserito non è in formato pdf.";
            case "FILE_PDF_TOOBIG_ERROR" : return "Il file pdf ha una dimensione eccedente il limite di 200MB.";
            case "F24_METADATA_NOT_VALID" : return "I dati contenuti del file dei metadati F24 non rispettano lo schema di validazione.";
            case "TAXID_NOT_VALID" : return "Codice fiscale del destinatario non corretto (non ancora implementato).";
            case "RECIPIENT_ID_NOT_VALID" : return "Destinatario non Valido (utilizzato solo per funzionalità non ancora implementate)";
            case "NOT_VALID_ADDRESS" : return "L'indirizzo di invio cartaceo inserito per il destinatario non ha superato i controlli di correttezza.";
            case "PAYMENT_NOT_VALID" : return "I dati del pagamento non sono sono registrati sulla piattaforma GPD (modalità asincrona di integrazione pagoPA)";
            case "SERVICE_UNAVAILABLE" : return "Il sistema non è attualmente disponibile.";
        }
        return errorCode.replaceAll("_"," ");
    }

}
